// Generic R2 file/template helpers
import { api } from './client';

export interface FileEntry {
  key: string;
  size: number;
  last_modified: string;
  url: string | null;
}

export const filesApi = {
  list: async (prefix: string) => (await api<{ data: FileEntry[] }>('/api/v2/files/list', { query: { prefix } })).data,
  presignPut: async (key: string, content_type: string) =>
    api<{ uploadUrl: string; finalUrl: string | null }>('/api/v2/files/presign-put', { method: 'POST', body: { key, content_type } }),
  presignGet: async (key: string, expires = 3600) =>
    api<{ downloadUrl: string }>('/api/v2/files/presign-get', { method: 'POST', body: { key, expires } }),
  remove: async (key: string) =>
    api('/api/v2/files', { method: 'DELETE', body: { key } }),
};

// Upload File via presigned PUT
export async function uploadFile(key: string, file: Blob | File, contentType?: string): Promise<string | null> {
  const ct = contentType || (file as any).type || 'application/octet-stream';
  const presign = await filesApi.presignPut(key, ct);
  const res = await fetch(presign.uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': ct },
    body: file,
  });
  if (!res.ok) throw new Error(`R2 upload failed: ${res.status}`);
  return presign.finalUrl;
}

// Download via presigned GET → returns Blob
export async function downloadFile(key: string): Promise<Blob> {
  const presign = await filesApi.presignGet(key);
  const res = await fetch(presign.downloadUrl);
  if (!res.ok) throw new Error(`Download failed: ${res.status}`);
  return await res.blob();
}
